<template>
  <div
    class="projectInfoPublic mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="infoWrap">
      <div class="listWrap">
        <template v-if="list.length">
          <IllustrateCom
            v-if="
              $route.path == '/systemDescription' ||
              $route.path == '/suggestions'
            "
            :list="list"
          />
          <InfoListCom
            v-else
            :list="list"
            :authority="authority"
            @getClickEdit="getClickEdit"
          />
        </template>
        <el-empty v-else description="暂无数据"></el-empty>
      </div>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 30, 50]"
      :page-size="page.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      style="text-align: right; margin-right: 30px"
    >
    </el-pagination>
    <div
      class="addBtn"
      v-if="authority && $route.path !== '/systemDescription'"
    >
      <el-button
        type="primary"
        icon="el-icon-plus"
        circle
        @click="
          dialogVisible = true;
          activeItem = {};
        "
      ></el-button>
    </div>
    <AddEditInfo
      v-if="dialogVisible && $route.path == '/projectInformation'"
      :activeItem="activeItem"
      @handleSubmit="handleSubmit"
    />
    <AddEditCourse
      v-if="dialogVisible && $route.path == '/historicalMonument'"
      :activeItem="activeItem"
      @handleSubmit="handleSubmit"
    />
    <AddEditSuggestions
      v-if="dialogVisible && $route.path == '/suggestions'"
      :activeItem="activeItem"
    />
  </div>
</template>

<script>
import api from "@/api";
import { judgeAuthority } from "@/assets/js/utils";
import { handleEditAuthority } from "@/assets/utils/handleData.js";
import InfoListCom from "@/components/xiangmuxinxi/InfoListCom.vue";
import AddEditInfo from "@/components/xiangmuxinxi/AddEditInfo";
import AddEditCourse from "@/components/xiangmuxinxi/AddEditCourse.vue";
import IllustrateCom from "@/components/xiangmuxinxi/IllustrateCom.vue";
import AddEditSuggestions from "@/components/xiangmuxinxi/AddEditSuggestions.vue";
export default {
  components: {
    InfoListCom,
    AddEditInfo,
    AddEditCourse,
    IllustrateCom,
    AddEditSuggestions,
  },
  data() {
    return {
      authority: false,
      list: [],
      currentPage: 1,
      page: {
        total: null,
        size: 5,
      },
      dialogVisible: false,
      clickItem: {},
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    getData() {
      if (
        this.$route.path == "/historicalMonument" ||
        this.$route.path == "/projectInformation"
      ) {
        this.getListData();
      } else if (this.$route.path == "/systemDescription") {
        this.list = [
          {
            name: "重庆巨基科技有限公司EMBS综合能源服务平台使用说明-v1.1.2",
            file: "EMBS使用说明书",
          },
          {
            name: "重庆巨基科技有限公司EMBS常见问题解答-v1.1.2",
            file: "EMBS常见QA",
          },
          {
            name: "重庆巨基科技有限公司巨能管APP使用说明书-v1.1.2",
            file: "巨能管使用说明书",
          },
          {
            name: "重庆巨基科技有限公司巨能管APP用户协议-v1.1.2",
            file: "巨能管用户协议",
          },
          {
            name: "重庆巨基科技有限公司EMBS综合能源服务平台用户协议-v1.1.2",
            file: "综合能源服务用户协议",
          },
        ];
      } else if (this.$route.path == "/suggestions") {
        this.list = [
          {
            name: "意见建议标题",
            time: "2023.07.21 12:12:03",
            describe:
              "这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长",
            file: "xxxxxxxxxxxx.docx",
          },
          {
            name: "意见建议标题",
            time: "2023.07.21 12:12:03",
            describe:
              "这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长",
            file: "xxxxxxxxxxxx.docx",
          },
          {
            name: "意见建议标题",
            time: "2023.07.21 12:12:03",
            describe:
              "这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长",
            file: "xxxxxxxxxxxx.docx",
          },
          {
            name: "意见建议标题",
            time: "2023.07.21 12:12:03",
            describe:
              "这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长这段描述很长很长很长很长很长很长很长很长很长很长很长很长很长很长",
            file: "xxxxxxxxxxxx.docx",
          },
        ];
      }
    },
    async getListData() {
      this.list = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.projectInfoGetList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        type: this.$route.path == "/historicalMonument" ? "历程" : "资讯",
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      if (res && res.data.code == 200) {
        let httpUrl = window.jujiParams.baseURL;
        this.$store.commit("SET_LOADING", false);
        this.list = res.data.data.data;
        this.list.map((v) => {
          if (this.$route.path == "/historicalMonument") {
            v.time = v.time.slice(0, 10);
          } else {
            v.imgUrl = v.image
              ? `${httpUrl}/${v.image}?tenant_id=${
                  JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
                }`
              : null;
          }
        });
        this.page.total = res.data.data.totalElements;
      }
    },
    getClickEdit(data) {
      this.dialogVisible = true;
      this.activeItem = data;
    },
    async handleSubmit(data) {
      let res = await api.projectInfoAddEdit({
        id: data.id ?? null,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        title: data.title,
        content: data.content,
        time: data.time,
        image: data.uri ?? null,
        type: this.$route.path == "/historicalMonument" ? "历程" : "资讯",
      });
      if (res && res.data.code == 200) {
        this.$message.success("操作成功！");
        setTimeout(() => {
          this.getListData();
          this.dialogVisible = false;
        }, 500);
      }
    },
  },
  created() {
    this.authority = judgeAuthority(handleEditAuthority(this.$route.path));
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.projectInfoPublic {
  position: relative;
  .addBtn {
    position: absolute;
    top: 3%;
    right: 3%;
  }
  .infoWrap {
    width: 100%;
    height: 90%;
    margin: 16px 0;
    overflow: auto;

    .listWrap {
      width: $innerWidth;
      background: #fff;
      border-radius: 6px;
      margin: 0 auto;
    }
  }
}
</style>
